import "@hotwired/turbo-rails";
import "flowbite";
import Rails from "@rails/ujs";

Rails.start();
